import { get, groupBy } from 'lodash';

import { getNodeId } from '../store/actionHandlers/common/adapterActions';
import { ROOT_NODE_ID } from '../../DynamicTree';
import orderBy from '../../../../utils/orderBy';

const UndefinedId = 'undefined';
const TreeNameId = 'null';

export default class NodeSorting {
  constructor({
    iteratees = 'name',
    orders = 'asc',
    getNodeParentId = 'parentId',
  } = {}) {
    this._getNodeParentId = getNodeParentId;

    if (this._isString(iteratees) || this._isFunc(iteratees)) {
      this.iteratees = [iteratees];
    } else if (this._isArray(iteratees)) {
      this.iteratees = iteratees;
    } else throw new Error('not supported');

    this.orders = orders;
  }

  get key() {
    return 'nodeSorting';
  }

  _isFunc = item => typeof item === 'function';

  _isArray = item => Array.isArray(item);

  _isString = item => typeof item === 'string';

  handleDidAddModels(treeState, inputModels, { adapter }) {
    const { children, models: treeModels } = treeState;

    const groupedByParent = groupBy(
      inputModels.filter(model => getNodeId(adapter, model) !== ROOT_NODE_ID),
      this._getNodeParentId,
    );

    Object.keys(groupedByParent).forEach(parentId => {
      let models = groupedByParent[parentId];
      const limit = 2;
      if (models.length < limit) {
        return;
      }

      parentId =
        (parentId === TreeNameId && children[ROOT_NODE_ID]) ||
        parentId === UndefinedId
          ? ROOT_NODE_ID
          : adapter.nodeParentId(models[0]);

      if (children[parentId] && children[parentId].length) {
        models = children[parentId].map(id => treeModels[id]).filter(m => m);
      }

      children[parentId] = this.sortModels(models).map(model =>
        getNodeId(adapter, model),
      );
    });
    return children;
  }

  handleDidUpdateTree(treeState, { adapter }) {
    const { inputModels } = treeState;
    this.handleDidAddModels(treeState, inputModels, { adapter });
  }

  sortModels(models) {
    return orderBy(
      models,
      this.iteratees.map(iterate => model => {
        let result;

        if (this._isFunc(iterate)) {
          result = iterate(model);
        } else if (this._isString(iterate)) {
          result = get(model, iterate, '');
        }

        return isNaN(result)
          ? String(result).toLowerCase().replace(' ', '')
          : result;
      }),
      this.orders,
    );
  }
}
